var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.83924 5.30354C8.83924 7.25625 7.25625 8.83924 5.30354 8.83924C3.35083 8.83924 1.76785 7.25625 1.76785 5.30354C1.76785 3.35083 3.35083 1.76785 5.30354 1.76785C7.25625 1.76785 8.83924 3.35083 8.83924 5.30354ZM8.37656 9.62657C7.50959 10.244 6.44897 10.6071 5.30354 10.6071C2.37448 10.6071 0 8.23261 0 5.30354C0 2.37448 2.37448 0 5.30354 0C8.23261 0 10.6071 2.37448 10.6071 5.30354C10.6071 6.44894 10.244 7.50954 9.62661 8.3765L13 11.7499L11.7499 12.9999L8.37656 9.62657Z",
    fill: "#8F8A8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.bcaf121f2985f510fca8b9786797d9c5.svg";
export { ForwardRef as ReactComponent };